export default "__VITE_ASSET__reHbYqfa__"